// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Chip_dataTypeButton__RKkgH {
    display: inline-block;
    font-size: 14px;
    line-height: 21px;
    border: 1px solid var(--color-143);
    border-radius: 19px;
    padding: 3px 10px;
    margin: 2px 5px;
    cursor: pointer;
}
.Chip_buttonSelected__tW2RX,
.Chip_dataTypeButton__RKkgH:hover,
.Chip_dataTypeButton__RKkgH:active {
    background: var(--color-142);
    border: 1px solid transparent;
}
`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Chip/Chip.module.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,kCAAkC;IAClC,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,eAAe;AACnB;AACA;;;IAGI,4BAA4B;IAC5B,6BAA6B;AACjC","sourcesContent":[".dataTypeButton {\n    display: inline-block;\n    font-size: 14px;\n    line-height: 21px;\n    border: 1px solid var(--color-143);\n    border-radius: 19px;\n    padding: 3px 10px;\n    margin: 2px 5px;\n    cursor: pointer;\n}\n.buttonSelected,\n.dataTypeButton:hover,\n.dataTypeButton:active {\n    background: var(--color-142);\n    border: 1px solid transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dataTypeButton": `Chip_dataTypeButton__RKkgH`,
	"buttonSelected": `Chip_buttonSelected__tW2RX`
};
export default ___CSS_LOADER_EXPORT___;
